import { render, staticRenderFns } from "./salaryTemplete.vue?vue&type=template&id=34a66962&scoped=true"
import script from "./salaryTemplete.vue?vue&type=script&lang=js"
export * from "./salaryTemplete.vue?vue&type=script&lang=js"
import style0 from "./salaryTemplete.vue?vue&type=style&index=0&id=34a66962&prod&lang=css"
import style1 from "./salaryTemplete.vue?vue&type=style&index=1&id=34a66962&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a66962",
  null
  
)

export default component.exports